import { content } from 'api';
import * as types from '../../mutationTypes';

export default {
    async getAll({ commit }) {
        const response = await content.getActivatedCEModules();
        commit(types.BULK_ADD_ACTIVATED_CEMODULES, response.data);
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/activatedCEModules/actions.js